export interface AppConfig {
  GatewayUrl: string;
}

let config: AppConfig | null = null;
let configPromise: Promise<AppConfig> | null = null;

export const loadConfig = (): Promise<AppConfig> => {
  if (configPromise) return configPromise;

  configPromise = fetch('/appsettings.json')
    .then(res => res.json())
    .then(loadedConfig => {
      config = loadedConfig;
      return loadedConfig;
    });

  return configPromise;
};

export const getConfig = (): Promise<AppConfig> => {
  if (config) {
    return Promise.resolve(config);
  }

  return loadConfig();
};
